var map = {
	"./icon-back.svg": "90c4",
	"./icon-corner.svg": "cede",
	"./icon-finish.svg": "3680",
	"./icon-link.svg": "3382",
	"./icon-mark.svg": "902d",
	"./icon-refresh.svg": "66ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";